import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { handle_alarm } from '@/api/pests';
import { formatYMDHMS } from '@/libs/util';
export default {
  data: function data() {
    return {
      ref: 'formItem',
      formItem: {
        handle_type_code: null
      },
      ruleValidate: {
        handle_type_code: [{
          required: true,
          message: '处理状态不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  props: {
    id: {},
    _vm: {},
    setData: {}
  },
  methods: {
    viewWb: function viewWb() {
      this._vm.$Message.warning('暂无维保信息');
    },
    submitMessage: function submitMessage() {
      var _this = this;

      this.$refs[this.ref].validate(function (valid) {
        if (valid) {
          handle_alarm(_objectSpread({
            id: _this.id
          }, _this.formItem, {
            handle_user_name: _this._vm.$store.state.user.userName,
            handle_user_time: formatYMDHMS(new Date().getTime() / 1000)
          })).then(function (res) {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);

              _this.$emit('init');
            } else {
              _this.$Message.error(res.errorMsg);
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {}
};